import { initChameleon } from 'trackers/chameleon'
import { initCrisp } from 'trackers/crisp'
import { init as initGA } from 'trackers/google-analytics/init'
import { initLinkedInPixel } from 'trackers/linkedin'
import { initMetaPixel } from 'trackers/meta'
import { initMicrosoftClarity } from 'trackers/microsoft-clarity'
import mixpanel from 'trackers/mixpanel'
import { initStonly } from 'trackers/stonly'

export async function loadTrackers(): Promise<void> {
  initGA()
  mixpanel.init()

  await Promise.allSettled([
    initLinkedInPixel(),
    initMetaPixel(),
    initMicrosoftClarity(),
  ])

  // Await Crisp before Stonly — Stonly's beforeunload handler accesses Crisp
  // session data, so Crisp must be fully loaded first.
  try {
    await initCrisp()
  } catch (error) {
    void error
  }

  initStonly()
  initChameleon()
}
